import TabPage from '@/components/TabPage';

export default function Sanyi() {
  return <TabPage chartFullKeys={['quality']} />;
}
